export default __webpack_public_path__ + "static/media/delete-icon.0a806159.png";